import { FC } from "react";

import DeleteModalItem from "../DeleteModalItem";
import {
  DeleteModalList,
  DeleteModalListContainer,
} from "./deleteModalListStyle";
import { GetVehicle } from "@data/repositories/Vehicle/queryVehicle";

export const DeleteVehicleList: FC<{ items?: GetVehicle[] }> = ({
  items = [],
}) => {
  return (
    <>
      <DeleteModalListContainer>
        <DeleteModalList>
          {items.length > 0 &&
            items.map((item, index) => (
              <DeleteModalItem vehicle={item} key={index} />
            ))}
        </DeleteModalList>
      </DeleteModalListContainer>
    </>
  );
};

export default DeleteVehicleList;
